export const musikUndEmotionenFAQ = [
  {
    question: "Wie hilft Musik, impulsive Entscheidungen zu vermeiden?",
    answer: "Sie dämpft dein limbisches System, fördert die Dopamin-Balance und stärkt den präfrontalen Cortex für rationale Überlegungen."
  },
  {
    question: "Gibt es wissenschaftliche Belege für den Effekt?",
    answer: "Ja. Studien zeigen, dass angenehme Musik die Aktivität im Nucleus Accumbens steigert – und damit dein Belohnungssystem anspricht."
  },
  {
    question: "Wie finde ich meine ideale Playlist?",
    answer: "Starte mit ruhigen Instrumentaltracks im 60–120 BPM-Tempo. Notiere, welche Songs dir Ruhe schenken und dich gleichzeitig fokussieren. Diese wirst du schnell als deine auditiven Anker erkennen."
  }
];
